import { Injectable, NgZone } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class RestaurantConnectionService {
  public scan$: Subject<any> = new Subject<any>();
  public printersAdded$: Subject<any> = new Subject<any>();

  constructor(private zone: NgZone) {
    window['ls_manager'] = {
      scan: (value: any): boolean => this.scan(value),
      detectprintersCallback: (): void => this.printersAdded()
    };
  }

  public scan(value: any): boolean {
    this.zone.run(() => {
      this.scan$.next(value);
    });
    return this.scan$.observers.length > 0;
  }

  public printersAdded(): void {
    this.zone.run(() => {
      this.printersAdded$.next();
    });
  }
}
